import { GiveawayEntry } from '@psl/flows/showcase/pages/giveaway/functions/types';
import { GiveawayEntrant } from '../../../models/ClientModels';
import { WithID } from '../../firebase/rxfireExtensions';

export const transformServerGiveawayEntrant = (
  userId: string,
  serverItem: GiveawayEntrant,
): WithID<GiveawayEntry> => {
  return {
    id: userId,
    userId,
    userProfile: serverItem.profile,
    joinedAt: serverItem.joinedAt.toDate(),
    winnerStatus: serverItem.status ?? 'notWinner',
  };
};
